module.exports = {
      id: "share-x-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-58d03b3f1466f1d475a0d37264fe8fc2.svg#share-x",
      toString: function () {
        return this.url;
      }
    }